import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { WhatsappTemplateButtonTypeEnum } from 'src/app/parameters/message-templates/whatsapp-templates/shared/models/whatsapp-template-button-type.enum';
import { BasicService } from 'src/app/shared/services/basic.service';
import { Template } from './shared/template.model';

@Component({
  selector: 'app-select-whatsapp-template',
  templateUrl: './select-whatsapp-template.component.html',
  styleUrls: ['./select-whatsapp-template.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SelectWhatsappTemplateComponent implements OnInit, OnDestroy {
  initialLang: string;
  availableTemplates: Template[];

  languagesSet: Set<string> = new Set();
  templatesFromLanguageMap: Map<string, Template[]> = new Map();
  templatesFromLanguage = [];
  selectedLanguageCode: string;
  title = this.basicService.translate('task/whatsapp-template/select-template');
  closeLabel = this.basicService.translate('close');

  WhatsappTemplateButtonTypeEnum = WhatsappTemplateButtonTypeEnum;
  searchCtrl = new FormControl('');
  subscriptions: Subscription = new Subscription();

  constructor(
    private basicService: BasicService,
    public dialogRef: MatDialogRef<SelectWhatsappTemplateComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { initialLang: string; availableTemplates: Template[] }
  ) {
    const { initialLang, availableTemplates } = this.data;
    this.initialLang = initialLang;
    this.availableTemplates = availableTemplates || ([{ language: 'en', text: '' }] as Partial<Template[]>);
  }

  ngOnInit() {
    const TEMPLATE_VARIABLES_RE = /\{\{[0-9]+\}\}/g;

    this.availableTemplates.forEach(template => {
      template.textWithReplacedPlaceholders = template.text.replace(
        TEMPLATE_VARIABLES_RE,
        match => template.displayed_placeholders[match].label || match
      );

      this.languagesSet.add(template.language);
      this.templatesFromLanguageMap.set(
        template.language,
        (this.templatesFromLanguageMap.get(template.language) || []).concat(template)
      );
    });
    if (this.languagesSet.has(this.initialLang)) {
      this.selectedLanguageCode = this.initialLang;
    } else {
      this.selectedLanguageCode = this.availableTemplates[0]?.language;
    }
    this.templatesFromLanguage = this.templatesFromLanguageMap.get(this.selectedLanguageCode);
    this.subscriptions.add(this.searchCtrl.valueChanges.pipe(debounceTime(300)).subscribe(this.filterTemplates));
  }

  private filterTemplates = (value: string) => {
    const templatesFromLanguage = this.templatesFromLanguageMap.get(this.selectedLanguageCode) || [];
    if (!value) {
      this.templatesFromLanguage = templatesFromLanguage;
    } else {
      this.templatesFromLanguage = templatesFromLanguage.filter(({ name, textWithReplacedPlaceholders }) =>
        new RegExp(value, 'gi').test(`${name}#${textWithReplacedPlaceholders}`)
      );
    }
  };

  languageCodeSelected(code) {
    this.selectedLanguageCode = code;
    this.templatesFromLanguage = this.templatesFromLanguageMap.get(code);
  }

  /**
   * Allows to clear the search filter.
   */
  clearSearch() {
    this.searchCtrl.reset();
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
